<template>
  <v-col cols="12">
    <v-row align="center" justify="space-between">
      <v-col cols="10">
        <v-text-field
          ref="entryBox"
          full-width
          filled
          dense
          hide-details="auto"
          v-model="newEntry"
          label="New Entry"
          single-line
          v-on:keyup.enter="saveEntry"
          v-on:keyup.space.ctrl="expandInput"
          append-icon="mdi-arrow-expand"
          @click:append="expandInput"
        />
      </v-col>
      <v-col cols="2" class="text-center">
        <v-btn
          @click="saveEntry"
          fab
          small
          :disabled="!newEntry"
          color="success"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="showLogButton"> </v-row>
    <v-dialog v-model="showInputDialog" fullscreen>
      <v-card>
        <v-btn fab text @click="showInputDialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-card-text>
          <v-row align="center">
            <v-col cols="12">
              <v-textarea
                ref="entryBox"
                autofocus
                filled
                dense
                rows="10"
                full-width
                hide-details="auto"
                v-model="newEntry"
                label="New Entry"
                v-on:keyup.enter.ctrl="saveEntry"
                v-on:keyup.space.ctrl="reset"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col cols="4" md="4" class="text-right">
            <v-row>
              <v-col>
                <v-btn @click="saveEntry" :disabled="!newEntry" color="success">
                  Log
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'Log',
    created() {},
    computed: {
      ...mapGetters('log', ['logItems']),
      rowCount() {
        return 2;
      },
      showLogButton() {
        if (this.newEntry) {
          return true;
        }
        return false;
      },
    },
    data() {
      return {
        newEntry: '',
        showInputDialog: false,
      };
    },
    methods: {
      expandInput() {
        this.showInputDialog = true;
      },
      reset() {
        this.showInputDialog = false;
      },
      //saveExpandedEntry(text) {
        //if (!text) {
          //return;
        //}
        //this.$store.dispatch('addUserEntry', { text: text }).then(() => {
          //this.newEntry = '';
        //});
      //},
      saveEntry() {
        this.showInputDialog = false;
        if (!this.newEntry) {
          return;
        }
        this.$store.dispatch('log/addUserEntry', { text: this.newEntry }).then(() => {
          this.newEntry = '';
        });
      },
    },
  };
</script>
